import React, { Fragment } from 'react';

import * as Yup from 'yup';
// this library provides a better email validation than yup.string().email()
// Yup.string.email allows turkish characters as valid in email address
import { validate } from 'email-validator';

Yup.addMethod(
  Yup.string,
  'emailAddress',
  function (config = { empty: '', invalid: '' }) {
    return this.test('emailAddress', config, function (value) {
      const { path, createError } = this;

      if (!value) {
        return createError({ path, message: config.empty });
      }

      if (!validate(value)) {
        return createError({
          path,
          message: config.invalid ?? 'INVALID EMAIL ADDRESS',
        });
      }

      return true;
    });
  }
);

export const isValidEmail = (text: string) => validate(text);

Yup.addMethod(
  Yup.string,
  'tckn',
  function (config = { empty: '', invalid: '' }) {
    return this.test('tckn', config, async function (value) {
      const { path, createError } = this;

      if (!value) {
        return createError({ path, message: config.empty });
      }

      if (!isTcknPossiblyValid(value)) {
        return createError({
          path,
          message: config.invalid ?? 'Invalid Identity Number',
        });
      }

      return true;
    });
  }
);

export const isTcknPossiblyValid = (value: number | string) => {
  value = value.toString();

  const isEleven = /^[0-9]{11}$/.test(value);

  let totalX = 0;

  for (let i = 0; i < 10; i++) {
    totalX += Number(value.substr(i, 1));
  }

  const isRuleX = totalX % 10 === +value.substr(10, 1);

  let totalY1 = 0;

  let totalY2 = 0;

  for (let i = 0; i < 10; i += 2) {
    totalY1 += Number(value.substr(i, 1));
  }

  for (let i = 1; i < 10; i += 2) {
    totalY2 += Number(value.substr(i, 1));
  }

  const isRuleY = (totalY1 * 7 - totalY2) % 10 === +value.substr(9, 0);

  return isEleven && isRuleX && isRuleY;
};

export const isCompanyNameValid = (value: string) => {
  const isValidFormat = /^(?=.*[A-ZÇĞİÖŞÜ])[A-ZÇĞİÖŞÜ0-9\W]+$/.test(value);
  return isValidFormat;
};

export const isUpperTextValid = (value: string) => {
  const isValidName = /^[a-zA-ZçÇğĞıİöÖşŞüÜ\s]+$/.test(value);
  return isValidName;
};

export const isEmailAddressValid = (value: string) => {
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
    value
  );
  return isValidEmail;
};

export const isHesCodePossiblyValid = (value: string) =>
  /^[a-z0-9]{4}-\d{4}-\d{2}$/i.test(value);

type Config = {
  empty?: string;
  invalid?: string;
  validator: (value: string) => boolean;
};

Yup.addMethod(Yup.string, 'customValidation', function (config: Config) {
  return this.test('customValidation', config, async function (value) {
    const { path, createError } = this;

    if (!value) {
      return createError({ path, message: config.empty });
    }

    if (!config.validator(value)) {
      return createError({
        path,
        message: config.invalid ?? 'Invalid Format',
      });
    }

    return true;
  });
});

export const FormatAmountInTurkishCurrency = ({
  amount,
  Wrapper = Fragment,
}: {
  amount: number;
  Wrapper?: React.ComponentType<
    React.PropsWithChildren<
      React.PropsWithChildren<
        React.PropsWithChildren<React.PropsWithChildren<unknown>>
      >
    >
  >;
}) => (
  <Wrapper>
    {Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount)}
    &nbsp;₺
  </Wrapper>
);
